export function calculateStockTime(stock: number): number {
  if (stock === 0 || stock === null) {
    return 1000 * 60 * 10; // 10mins
  }
  if (stock >= 1000) {
    return 1000 * 60 * 5; // 5mins;
  }
  if (stock < 1000 && stock >= 500) {
    return 1000 * 60; // 1min;
  }
  if (stock < 500) {
    return 1000 * 20; // 20s;
  }
  if (stock === undefined) {
    return 1000 * 20; // 20s;
  }
}
